import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { PopupModule } from '@progress/kendo-angular-popup';
import { ServicesGridComponent } from './services-grid/services-grid.component';
import { SharedModule } from '../shared/shared.module';
import { AssignmentsComponent } from './assignments/assignments.component';
import { AssignmentComponent } from './assignment/assignment.component';
import { AssignmentDetailComponent } from './assignment/assignment-detail/assignment-detail.component';
import { AssignmentTimeEntriesComponent } from './assignment/assignment-time-entries/assignment-time-entries.component';
import { AssignmentTimeServicesComponent } from './assignment/assignment-services/assignment-services.component';
import { AssignmentTimeSchedulerComponent } from './assignment/assignment-scheduler/assignment-scheduler.component';
import { AssignmentReportComponent } from './assignment/assignment-report/assignment-report.component';
import { AttachmentsComponent } from 'src/app/shared/attachments/attachments.component';
import { AssignmentTypeComponent } from './assignment-type/assignment-type.component';



@NgModule({
  declarations: [
    ServicesGridComponent,
    AssignmentsComponent,
    AssignmentComponent,
    AssignmentDetailComponent,
    AssignmentTimeEntriesComponent,
    AssignmentTimeServicesComponent,
    AssignmentTimeSchedulerComponent,
    AssignmentReportComponent,
    AssignmentTypeComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    PopupModule,
    AttachmentsComponent
  ]
})
export class AssignmentModule { }
